<template>
    <b-modal
        @ok="handleCreateOk"
        @close="hideModal"
        @cancel="hideModal"
        @hidden="hideModal"
        ref="create-schedule-tournament-modal"
        :title="$t('scheduled_tournament_calendar.create_modal.title')"
        ok-title="Create"
        :cancel-title="$t('scheduled_tournament_calendar.btn.cancel')"
        size="lg"
        >
      <b-form-group
          :label="$t('scheduled_tournament_calendar.form.label.name')">
        <b-form-input
            v-model="name"
            trim>
        </b-form-input>
      </b-form-group>

      <b-form-group
          :label="$t('scheduled_tournament_calendar.create_modal.label.date_start')"
          label-for="dateStart"
      >
        <datetime
            v-model="dateStart"
            type="datetime"
            input-class="form-control"
            value-zone="UTC"
            zone="UTC"
            format="yyyy-MM-dd HH:mm:ss"
            :phrases="{ok: $t('scheduled-tournament.btn.date_time.continue'), cancel: $t('scheduled-tournament.btn.date_time.exit')}"
            :hour-step="1"
            :minute-step="1"
            :week-start="7"

        ></datetime>

      </b-form-group>

      <b-form-group
          :label="$t('scheduled_tournament_calendar.create_modal.label.notification')"
          label-for="notification"
      >
        <multiselect v-model="notification"
                     label="name"
                     track-by="id"
                     :options="options.notifications"
                     :multiple="false"
                     id="notification"
        >
        </multiselect>
      </b-form-group>

      <b-form-group
          :label="$t('scheduled_tournament_calendar.create_modal.label.segment')"
          label-for="segment"
      >
        <multiselect v-model="segment"
                     label="name"
                     track-by="id"
                     :options="options.segments"
                     :multiple="false"
                     id="segment"
        >
        </multiselect>
      </b-form-group>

      <router-link :to="{ name: 'user-notification-list'}" class="link-primary">{{ $t('scheduled_tournament_calendar.notification_link') }}</router-link>

      <b-form-group
          :label="$t('scheduled_tournament_calendar.create_modal.label.note')"
          label-for="note"
          class="mt-3"
      >
        <b-form-textarea
            v-model="note"
            rows="3"
            max-rows="6"
            id="note"
        ></b-form-textarea>
      </b-form-group>
    </b-modal>
</template>

<script>
import axios from 'axios';
import Multiselect from "vue-multiselect";
import { Datetime } from 'vue-datetime';
import moment from "moment";

//TODO: import / load / get locale the right way
let locale = locale ? locale : "en";

export default {
  components: {Multiselect, Datetime},
  props: ['apiKey', 'dayDate'],
  data() {
    return {
      name: null,
      notification: [],
      note: '',
      segment: [],
      dateStart: null,
      options: {
        notifications: [],
        segments: []
      }
    };
  },
  mounted() {
    this.getAvailableNotifications();
    this.getAvailableSegments();
  },
  methods: {
    getAvailableNotifications() {
      axios.get('/api/inbox/notifications?limit=2000')
        .then(resp => {
          this.options.notifications = resp.data.items;
        });
    },
    getAvailableSegments() {
      axios.get('/api/segments?limit=2000')
          .then(resp => {
            this.options.segments = resp.data.items;
          });
    },
    handleCreateOk(bvModalEvt) {
      bvModalEvt.preventDefault()
      this.handleCreateSubmit()
    },
    handleCreateSubmit() {
      const form = {
        name: this.name,
        date: this.dateStart
      }

      this.$router.push({ name: 'scheduled-tournament', params: { form: form }});
    },
    openModal(date) {
      this.dateStart = moment(date).set("hour", 14).set("minute", 0).format();

      this.$refs['create-schedule-tournament-modal'].show();
    },
    hideModal() {
      this.$refs['create-schedule-tournament-modal'].hide();
    },
    validateState(entry) {
      if (entry.constructor.name === 'Array') {
        switch (entry.length) {
          case 3:
            entry = this.$v.data[entry[0]][entry[1]][entry[2]];
            break;
          case 2:
            entry = this.$v.data[entry[0]][entry[1]];
            break;
        }
      } else {
        entry = this.$v.data[entry];
      }
      const {$dirty, $error} = entry;
      return $dirty ? !$error : null;
    },
  }
}
</script>